import { alpha, Box, Card, makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles(({ spacing, palette }) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: spacing(1),
  },
  headerTitle: {
    fontWeight: 500,
    color: alpha(palette.primary.main, 0.7),
  },
  rootList: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1),
  },
  cardRoot: {
    padding: spacing(2),
    backgroundColor: palette.background.default,
  },
  rootListOpportunity: {
    marginTop: spacing(1),
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1),
  },
  cardRootOpportunity: {
    padding: spacing(1),
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(0.5),
  },
  cardOpportunityHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: spacing(1),
  },
  duration: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(1),
  },
  divider: {
    marginBottom: spacing(1),
  },
  buttonSkeleton: {
    borderRadius: 8,
  },
  tagsContainer: {
    display: 'flex',
    alignItems: 'center',
    gridGap: spacing(0.5),
  },
  chipSkeleton: {
    borderRadius: 16,
  },
  valueSourceContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  metadataContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

function ContactFunnelTabPanelSkeleton() {
  const classes = useStyles();

  return (
    <Box>
      {/* HEADER */}
      <Box className={classes.header}>
        <Skeleton width={140} height={20} />

        <Box style={{ display: 'flex', gap: 8 }}>
          <Skeleton
            style={{ borderRadius: 8 }}
            width={24}
            height={24}
            variant="rect"
          />

          <Skeleton width={120} height={20} />
        </Box>
      </Box>

      {/* LIST */}
      <Box className={classes.rootList}>
        {[1, 2, 3].map(funnelIndex => (
          <Card className={classes.cardRoot} elevation={0} key={funnelIndex}>
            {/* FUNNEL TITLE */}
            <Skeleton width={120} height={20} />

            {/* LIST OF OPPORTUNITIES */}
            <Box className={classes.rootListOpportunity}>
              {[1].map(opportunityIndex => (
                <Card
                  className={classes.cardRootOpportunity}
                  elevation={0}
                  key={opportunityIndex}
                >
                  {/* HEADER: Stage name and duration */}
                  <Box className={classes.cardOpportunityHeader}>
                    <Skeleton width={100} height={20} />
                    <Box className={classes.duration}>
                      <Skeleton variant="circle" width={20} height={20} />
                      <Skeleton width={60} height={16} />
                    </Box>
                  </Box>

                  {/* DIVIDER */}
                  <Box className={classes.divider}>
                    <Skeleton variant="rect" height={1} />
                  </Box>

                  {/* TAGS */}
                  <Box className={classes.tagsContainer}>
                    <Skeleton
                      variant="rect"
                      className={classes.chipSkeleton}
                      width={60}
                      height={24}
                    />
                    <Skeleton
                      variant="rect"
                      className={classes.chipSkeleton}
                      width={80}
                      height={24}
                    />
                  </Box>

                  {/* DESCRIPTION */}
                  <Box>
                    <Skeleton width="100%" height={16} />
                    <Skeleton width="80%" height={16} />
                  </Box>

                  {/* VALUE AND SOURCE */}
                  <Box className={classes.valueSourceContainer}>
                    <Skeleton width={80} height={20} />
                    <Skeleton width={100} height={16} />
                  </Box>

                  {/* STATUS */}
                  <Box>
                    <Skeleton
                      variant="rect"
                      className={classes.chipSkeleton}
                      width={90}
                      height={24}
                    />
                  </Box>

                  {/* METADATA: Created date and code */}
                  <Box className={classes.metadataContainer}>
                    <Skeleton width={150} height={16} />
                    <Skeleton width={80} height={16} />
                  </Box>
                </Card>
              ))}
            </Box>
          </Card>
        ))}
      </Box>
    </Box>
  );
}

export default ContactFunnelTabPanelSkeleton;
